/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Food Security Exchange API
 * REST API for the FSE platform. Endpoints by BRS module (PLAN.md §5).
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  KycDto,
  KycPendingListDto,
  ReviewKycDto,
  SubmitKycDto
} from '.././models';

import { fseAxios } from '../../client';




/**
 * Records the caller's FICA tier intent + bumps users.fica_status to submitted. No Smile ID call yet — that's partner-lane work (D-011). Upsert semantics on user_id.
 * @summary Submit KYC intent (self — stub per PLAN.md §6)
 */
export const kycControllerSubmit = (
    submitKycDto: SubmitKycDto,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<KycDto>(
      {url: `/kyc`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitKycDto, signal
    },
      );
    }
  


export const getKycControllerSubmitMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof kycControllerSubmit>>, TError,{data: SubmitKycDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof kycControllerSubmit>>, TError,{data: SubmitKycDto}, TContext> => {

const mutationKey = ['kycControllerSubmit'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof kycControllerSubmit>>, {data: SubmitKycDto}> = (props) => {
          const {data} = props ?? {};

          return  kycControllerSubmit(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type KycControllerSubmitMutationResult = NonNullable<Awaited<ReturnType<typeof kycControllerSubmit>>>
    export type KycControllerSubmitMutationBody = SubmitKycDto
    export type KycControllerSubmitMutationError = unknown

    /**
 * @summary Submit KYC intent (self — stub per PLAN.md §6)
 */
export const useKycControllerSubmit = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof kycControllerSubmit>>, TError,{data: SubmitKycDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof kycControllerSubmit>>,
        TError,
        {data: SubmitKycDto},
        TContext
      > => {

      const mutationOptions = getKycControllerSubmitMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Read own KYC state
 */
export const kycControllerGetMe = (
    
 signal?: AbortSignal
) => {
      
      
      return fseAxios<KycDto>(
      {url: `/kyc/me`, method: 'GET', signal
    },
      );
    }
  



export const getKycControllerGetMeQueryKey = () => {
    return [
    `/kyc/me`
    ] as const;
    }

    
export const getKycControllerGetMeQueryOptions = <TData = Awaited<ReturnType<typeof kycControllerGetMe>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof kycControllerGetMe>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getKycControllerGetMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof kycControllerGetMe>>> = ({ signal }) => kycControllerGetMe(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof kycControllerGetMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type KycControllerGetMeQueryResult = NonNullable<Awaited<ReturnType<typeof kycControllerGetMe>>>
export type KycControllerGetMeQueryError = unknown


export function useKycControllerGetMe<TData = Awaited<ReturnType<typeof kycControllerGetMe>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof kycControllerGetMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof kycControllerGetMe>>,
          TError,
          Awaited<ReturnType<typeof kycControllerGetMe>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useKycControllerGetMe<TData = Awaited<ReturnType<typeof kycControllerGetMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof kycControllerGetMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof kycControllerGetMe>>,
          TError,
          Awaited<ReturnType<typeof kycControllerGetMe>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useKycControllerGetMe<TData = Awaited<ReturnType<typeof kycControllerGetMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof kycControllerGetMe>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Read own KYC state
 */

export function useKycControllerGetMe<TData = Awaited<ReturnType<typeof kycControllerGetMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof kycControllerGetMe>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getKycControllerGetMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Lists users with fica_status=submitted. admin sees all; coop_admin sees submitted farmers in cooperatives they admin; group_lead sees submitted members of their informal group (TD-057). Newest-first. Powers the web + mobile vouch UIs.
 * @summary Tier-1 KYC review inbox — list submissions awaiting review
 */
export const kycControllerListPending = (
    
 signal?: AbortSignal
) => {
      
      
      return fseAxios<KycPendingListDto>(
      {url: `/kyc/pending`, method: 'GET', signal
    },
      );
    }
  



export const getKycControllerListPendingQueryKey = () => {
    return [
    `/kyc/pending`
    ] as const;
    }

    
export const getKycControllerListPendingQueryOptions = <TData = Awaited<ReturnType<typeof kycControllerListPending>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof kycControllerListPending>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getKycControllerListPendingQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof kycControllerListPending>>> = ({ signal }) => kycControllerListPending(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof kycControllerListPending>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type KycControllerListPendingQueryResult = NonNullable<Awaited<ReturnType<typeof kycControllerListPending>>>
export type KycControllerListPendingQueryError = unknown


export function useKycControllerListPending<TData = Awaited<ReturnType<typeof kycControllerListPending>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof kycControllerListPending>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof kycControllerListPending>>,
          TError,
          Awaited<ReturnType<typeof kycControllerListPending>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useKycControllerListPending<TData = Awaited<ReturnType<typeof kycControllerListPending>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof kycControllerListPending>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof kycControllerListPending>>,
          TError,
          Awaited<ReturnType<typeof kycControllerListPending>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useKycControllerListPending<TData = Awaited<ReturnType<typeof kycControllerListPending>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof kycControllerListPending>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Tier-1 KYC review inbox — list submissions awaiting review
 */

export function useKycControllerListPending<TData = Awaited<ReturnType<typeof kycControllerListPending>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof kycControllerListPending>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getKycControllerListPendingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * coop_admin sees farmers in cooperatives they admin; group_lead sees members of their group (403 otherwise).
 * @summary Read another user's KYC state (admin / coop_admin)
 */
export const kycControllerGetByUserId = (
    userId: string,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<KycDto>(
      {url: `/kyc/${userId}`, method: 'GET', signal
    },
      );
    }
  



export const getKycControllerGetByUserIdQueryKey = (userId?: string,) => {
    return [
    `/kyc/${userId}`
    ] as const;
    }

    
export const getKycControllerGetByUserIdQueryOptions = <TData = Awaited<ReturnType<typeof kycControllerGetByUserId>>, TError = unknown>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof kycControllerGetByUserId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getKycControllerGetByUserIdQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof kycControllerGetByUserId>>> = ({ signal }) => kycControllerGetByUserId(userId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof kycControllerGetByUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type KycControllerGetByUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof kycControllerGetByUserId>>>
export type KycControllerGetByUserIdQueryError = unknown


export function useKycControllerGetByUserId<TData = Awaited<ReturnType<typeof kycControllerGetByUserId>>, TError = unknown>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof kycControllerGetByUserId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof kycControllerGetByUserId>>,
          TError,
          Awaited<ReturnType<typeof kycControllerGetByUserId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useKycControllerGetByUserId<TData = Awaited<ReturnType<typeof kycControllerGetByUserId>>, TError = unknown>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof kycControllerGetByUserId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof kycControllerGetByUserId>>,
          TError,
          Awaited<ReturnType<typeof kycControllerGetByUserId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useKycControllerGetByUserId<TData = Awaited<ReturnType<typeof kycControllerGetByUserId>>, TError = unknown>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof kycControllerGetByUserId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Read another user's KYC state (admin / coop_admin)
 */

export function useKycControllerGetByUserId<TData = Awaited<ReturnType<typeof kycControllerGetByUserId>>, TError = unknown>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof kycControllerGetByUserId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getKycControllerGetByUserIdQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * admin, coop_admin, or group_lead records the vouch decision on a *submitted* KYC record. coop_admin must admin the target farmer's cooperative; group_lead must lead the target's informal group (TD-057); 403 otherwise. On verified, expires_at is set to now()+12 months; on rejected it is cleared. Target must currently be fica_status=submitted (else 400 not_pending). reviewerNote is persisted to audit only. Returns the updated KYC state.
 * @summary Tier-1 KYC review decision (approve / reject)
 */
export const kycControllerReview = (
    userId: string,
    reviewKycDto: ReviewKycDto,
 ) => {
      
      
      return fseAxios<KycDto>(
      {url: `/kyc/${userId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: reviewKycDto
    },
      );
    }
  


export const getKycControllerReviewMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof kycControllerReview>>, TError,{userId: string;data: ReviewKycDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof kycControllerReview>>, TError,{userId: string;data: ReviewKycDto}, TContext> => {

const mutationKey = ['kycControllerReview'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof kycControllerReview>>, {userId: string;data: ReviewKycDto}> = (props) => {
          const {userId,data} = props ?? {};

          return  kycControllerReview(userId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type KycControllerReviewMutationResult = NonNullable<Awaited<ReturnType<typeof kycControllerReview>>>
    export type KycControllerReviewMutationBody = ReviewKycDto
    export type KycControllerReviewMutationError = unknown

    /**
 * @summary Tier-1 KYC review decision (approve / reject)
 */
export const useKycControllerReview = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof kycControllerReview>>, TError,{userId: string;data: ReviewKycDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof kycControllerReview>>,
        TError,
        {userId: string;data: ReviewKycDto},
        TContext
      > => {

      const mutationOptions = getKycControllerReviewMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    